import React from 'react';
import { CtaButton } from './CtaButton';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaBlockProps {
  label?: string;
  note?: string;
  href?: string;
}
export function CtaBlock({
  label = '🚀 Sí, quiero comenzar ahora',
  note = 'Acceso Inmediato • Garantía de 7 Días',
  href = OFFER_ANCHOR
}: CtaBlockProps) {
  return <div className="mx-auto mt-5 max-w-md text-center" data-id="element-157" data-mp="3im2qm9piof65">
      <CtaButton href={href} data-id="element-158" data-mp="j5cssxqfxh32">{label}</CtaButton>
      {note && <p className="mt-2 text-xs text-muted" data-id="element-159" data-mp="j30agjgrt4ph">{note}</p>}
    </div>;
}